<template>
  <div class="aside-popular animated fadeInRight delay-1s">
    <!-- animated fadeInRight delay-1s -->
    <v-col cols="12" class="text-center">
      <p class="font-weight-bold mb-0">Posts populares</p>
    </v-col>
    <v-col cols="12" class="d-flex pt-0" v-for="item in filterViews" :key="item._id">
      <v-col cols="3" class="content-section-img">
        <img class="section-img" :src="item.imageURL" alt="">
      </v-col>
      <v-col class="content-section-text pb-0" cols="9">
        <p class="content-section-text__content">{{item.description.substr(0,70)}}</p>
        <p class="more-view"><span><i class="fas fa-eye"></i>{{item.views}}</span><router-link class="link" :to="{name: 'blog', params: { id: item._id }}" target="_blank">Ver Más</router-link></p>
      </v-col>
    </v-col>
  </div>
</template>

<script>
import {mapState} from 'vuex';
  export default {
    name:'section-lateral',
    created(){
      this.$store.dispatch('cargarDatosViews')
    },
    data(){
      return {
      }
    },
    computed:{
      filterViews(){
        return this.$store.getters.filterViews;
      }
    }
  }
</script>

<style lang="scss" scoped>
.aside-popular{
  border:1px solid #E0E0E0 !important;
  border-radius:7px;
  background: #fff;
  position: -webkit-sticky;
  position: sticky;
  top: 80px;
  // -webkit-box-shadow: 4px 5px 18px -3px #000000; 
  // box-shadow: 4px 5px 18px -3px #000000;
  @media screen and (max-width:900px){
    padding: .5rem 2rem;
    position: static;
    top: 0;
  }
}
.content-section-img{
  padding: 12px 0;
  @media screen and (max-width:900px){
    text-align:center;
  }
  @media screen and (max-width:600px){
    text-align:none;
  }
  & img{
    border-radius: 50% !important; 
    height:60px; 
    width:60px;
    @media screen and (max-width:900px){
      height:80px; 
      width:80px;
    }
    @media screen and (max-width:600px){
      height:60px; 
      width:60px;
    }
    
  }
}
.content-section-text{
  & p {
    font-size: .8rem;
  }

}
.link{
  text-decoration: none;
  float: right;
}
.more-view{
  display:flex;
  justify-content:flex-end;
  margin:0;
  & span{
    color:#757575;
    margin-right:.7rem;
    & i {
      margin-right:.2rem;
    }
  }
  & a{
    color:#2F1640;
  }
}

.animated{
   @media screen and (max-width:900px){
         -webkit-animation-duration: 0;
  animation-duration: 0;
  -webkit-animation-fill-mode: none;
  animation-fill-mode: none;
   }
}

.animated.delay-1s{
  @media screen and (max-width:900px){
    -webkit-animation-delay: none;
    animation-delay: none;
  }
}

.fadeInRight{
  @media screen and (max-width:900px){
    -webkit-animation-name: none;
    animation-name: none;
  }
}
</style>